import React from "react";

export default function TackSection() {
  return (
    <section className="tack-section">
      <div className="peach-block tack-card">
        <img
          className="tack-image"
          src="/images/ty2.jpg"
          alt="Tack för en fantastisk bröllopshelg"
        />

        <h2>Tack!</h2>

        <p>
          Wow, vilken fantastisk helg. Stort tack för att ni var med
          och gjorde den helt oförglömlig. Vi är fortfarande uppe bland
          molnen och går runt och fånler. Det är gästerna som gör festen!
        </p>
      </div>
    </section>
  );
}